/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { CART_LINE_ID_FIELD } from "../constants/constants";

// Invoice lines → SummaryItemsTable item shape. `lineId` lets the table resolve any
// line type back to its line, not just booking-flow service matches.
export const invoiceLinesToItems = (invoice) =>
  (invoice?.lines || []).map((line) => {
    const idField = CART_LINE_ID_FIELD[line.type];

    return {
      id: idField ? line[idField] : line.id,
      lineId: line.id,
      type: line.type,
      qty: line.qty,
      name: line.name,
      duration: line.duration,
      price: line.price,
    };
  });
